module.exports = __webpack_public_path__ + "img/ddwu_gallery4.4803e49d.jpg";